module.exports = __webpack_public_path__ + "img/SprayPainting3.87b84d19.jpg";